import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-widget-single-article',
  templateUrl: './widget-single-article.component.html',
  styleUrls: ['./widget-single-article.component.scss']
})
export class WidgetSingleArticleComponent {
  @Input({ required: true }) widgetData: any;
}
